import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api-client";
import type { PeakHourCell } from "../components/PeakHoursHeatmap";

export interface PeakHoursData {
  grid: PeakHourCell[];
}

export function usePeakHours(from?: string, to?: string) {
  const [data, setData] = useState<PeakHoursData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const params = new URLSearchParams();
      if (from) params.set("from", from);
      if (to) params.set("to", to);
      const query = params.toString() ? `?${params.toString()}` : "";
      const result = await api.get<PeakHoursData>(`/analytics/peak-hours${query}`);
      setData(result);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Failed to load peak hours data");
    } finally {
      setIsLoading(false);
    }
  }, [from, to]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, isLoading, error, refetch: fetchData };
}
